import { render, staticRenderFns } from "./PaymentMethodDetail.vue?vue&type=template&id=6830705e&scoped=true&"
import script from "./PaymentMethodDetail.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830705e",
  null
  
)

export default component.exports